import { axiosPublic } from './axiosInstance';

export const getTerms = () =>
  axiosPublic.get('/v1/terms').then(r => r.data.data);

export const getTermVersionHistory = (termId) =>
  axiosPublic.get(`/v1/terms/${termId}/versions`).then(r => r.data.data);

export const getTermVersionDetail = (termId, versionId) =>
  axiosPublic.get(`/v1/terms/${termId}/versions/${versionId}`).then(r => r.data.data);
